import React from 'react';

import {
  AccountCircle as AccountCircleIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon
} from '@mui/icons-material';
import {
  Button,
  styled,
  Typography
} from '@mui/material';

import * as SuperAdminUserMenu from './components/SuperAdminUserMenu';
import * as UserMenu from './components/UserMenu';
import * as dataService from './dataService';



const StyledTypography = styled(Typography)(({ theme }) => ({
  marginLeft: theme.spacing(1),
  marginRight: theme.spacing(1),
  textTransform: 'initial'
}));



interface IProps {
  colorVariant?: 'dark' | 'light'
}

export const FC: React.FC<IProps> = props => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const { loading, data } = dataService.useUserAccountButton();



  return loading ? (
    <></>
  ) : (
    <>
      <Button
        variant="text"
        onClick={evt => setAnchorEl(evt.currentTarget)}>
        <AccountCircleIcon style={{ color: data.isSuperAdmin ? '#E16B50' : '#87ACB9' }} />

        <StyledTypography style={{ color: props.colorVariant === 'dark' ? '#C3D1D8' : '#528898' }}>
          {data.fullName}
        </StyledTypography>

        <KeyboardArrowDownIcon style={{ color: '#87ACB9' }} />
      </Button>

      {data.isSuperAdmin ? (
        <SuperAdminUserMenu.FC
          anchorEl={anchorEl}
          onClose={() => setAnchorEl(null)} />
      ) : (
        <UserMenu.FC
          anchorEl={anchorEl}
          onClose={() => setAnchorEl(null)} />
      )}
    </>
  );
};
